/*
 * fn: stripUndefined
 *
 * Removes props whose value is undefined from an object
 *
 */
import { isDefined } from './isDefined'

export const stripUndefined = <T extends object>(obj: T): T =>
  Object.fromEntries(Object.entries(obj).filter(([, value]) => isDefined(value))) as T
